import React from 'react';
import { Link } from 'react-router-dom';

export default function PublicFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mf-footer" aria-label="Site footer">
      <div className="mf-footer__inner">

        {/* Brand column */}
        <div className="mf-footer__brand">
          <Link to="/" className="mf-footer__logo">Suitestream</Link>
          <p className="mf-footer__tagline">
            The operating system for venue attention. One platform connecting website,
            Wi-Fi, QR, screens, audio, and analytics.
          </p>
          <div className="mf-footer__ctas">
            <Link to="/signup" className="mf-footer__cta mf-footer__cta--primary">Start Free</Link>
            <Link to="/contact" className="mf-footer__cta mf-footer__cta--ghost">Book a Demo</Link>
          </div>
        </div>

        {/* Product column */}
        <div className="mf-footer__col">
          <div className="mf-footer__col-title">Platform</div>
          <nav aria-label="Platform links">
            <Link to="/">Website &amp; Landing Pages</Link>
            <Link to="/">Guest Wi-Fi</Link>
            <Link to="/">QR Codes &amp; Plaques</Link>
            <Link to="/">TV &amp; Signage</Link>
            <Link to="/">Audio Announcements</Link>
            <Link to="/">Audience Analytics</Link>
          </nav>
        </div>

        {/* Solutions column */}
        <div className="mf-footer__col">
          <div className="mf-footer__col-title">Solutions</div>
          <nav aria-label="Solutions links">
            <Link to="/">Restaurants &amp; Cafes</Link>
            <Link to="/">Bars &amp; Beach Clubs</Link>
            <Link to="/">Hotels &amp; Resorts</Link>
            <Link to="/">Retail &amp; Service</Link>
            <Link to="/">Tourist Attractions</Link>
            <Link to="/">Multi-Site Groups</Link>
          </nav>
        </div>

        {/* Company column */}
        <div className="mf-footer__col">
          <div className="mf-footer__col-title">Company</div>
          <nav aria-label="Company links">
            <Link to="/about">About</Link>
            <Link to="/subscription">Pricing</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </nav>
        </div>

      </div>

      <div className="mf-footer__bottom">
        <span>&copy; {year} Suitestream. Built for real places.</span>
        <span className="mf-footer__legal">
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
        </span>
      </div>
    </footer>
  );
}
